export default __webpack_public_path__ + "static/media/elige_comercio.9d908d35.png";